import React, { FC } from 'react';
import styled from 'styled-components';
import upperFirst from 'lodash/upperFirst';

const RootRuleErrors: FC<RootRuleErrorsType> = ({ errors = [] }) => {
  const rootErrors = errors.filter(error => !('attr' in error));
  if (!rootErrors.length) {
    return null;
  }

  return (
    <StyledErrorSection>
      {rootErrors.map(error => {
        return <div key={error.code}>{getErrorDetail(error)}</div>;
      })}
    </StyledErrorSection>
  );
};

type RootRuleErrorsType = {
  errors: any[];
};

function getErrorDetail(error: any): string {
  if (error.code === 'version_outdated') {
    return 'The rule has been updated by another user. Please reload the page and try again.';
  }
  return upperFirst(error.detail);
}

const StyledErrorSection = styled.div`
  color: ${p => p.theme.colors.red400};
  margin-top: ${p => p.theme.spacing.xsmall};
`;

export default RootRuleErrors;
